import { useCallback, useReducer, useState } from "react";
import { reducer } from "../Reducers/reducer";
import { ApiConnector, setToken } from "common/ApiConnector";
import { sprintf } from "sprintf-js";
import { useTableBase } from "ComponentHooks/useTableBase";
import { App } from "antd";
import { useFormBase } from "ComponentHooks/useFormBase";
import { useModalBase } from "ComponentHooks/useModalBase";
import { FormComponent } from "../Contacts/FormComponent";
import { Tooltip } from "antd";

const url_endpoint = "api/v1/contacts";

export const useContacts = (cat_user_id) => {
    const modalBase = useModalBase(<FormComponent />, "Formulario");
    const FormBase = useFormBase();
    const { modal, notification } = App.useApp();
    const tableBase = useTableBase();
    const [items, dispatch] = useReducer(reducer, []);
    const [editID, setEditID] = useState(0);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: true,
            width: 40,
            className: 'fw-bold',
            align: 'center',
            render: (value) => (<>{sprintf('%04d', value)}</>)
        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            width: 200,
            filterDropdown: tableBase.getColumnSearchProps('name').filterDropdown,
            // onFilterDropdownOpenChange: tableBase.getColumnSearchProps('name').onFilterDropdownOpenChange
        },
        {
            title: 'Número',
            dataIndex: 'number',
            key: 'number',
            sorter: true,
            width: 150,
            render: (value) => value ? `+${value}` : `-`,
            filterDropdown: tableBase.getColumnSearchProps('number').filterDropdown,
        },
        {
            title: 'Bloqueado',
            dataIndex: 'blocked',
            key: 'blocked',
            sorter: true,
            width: 50,
            render: (value) => (value) ? <span className="text-danger fw-bold"><i className="fas fa-times me-2"></i>Bloqueado</span> : "No"
        },
        {
            title: '*',
            dataIndex: 'id',
            key: 'buttons',
            width: 60,
            className: 'text-center',
            render: (value, row) => (
                <>
                    <Tooltip title="Editar">
                        <button className="btn btn-sm text-secondary py-0 px-2 me-2"
                            onClick={() => editItem(row)}
                        >
                            <i className="fas fa-pen"></i>
                        </button>
                    </Tooltip>
                    <Tooltip title="Editar">
                        <button className="btn btn-sm text-secondary py-0 px-2"
                            onClick={() => deleteItem(value)}
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    </Tooltip>
                </>
            )
        },
    ];

    const updateToken = async () => {
        await setToken(atob(cat_user_id));
    }

    const handleTableChange = useCallback(
        (pagination, filters, sorter, extra) => { fillItems({ filters, sorter, pagination }) },
        []);

    const fillItems = useCallback(async (params = tableBase.tableParams) => {
        const { columnKey: column, order } = params.sorter;
        const { current: page, pageSize } = params.pagination;

        try {
            tableBase.loading();
            let { data } = await ApiConnector.get(`${url_endpoint}`, {
                params: {
                    filters: params.filters,
                    sorter: { column, order },
                    pagination: { pageSize, page },
                }
            });
            let { items, total } = data;
            dispatch({ type: "FILL", payload: items });
            tableBase.updateTableParams({
                ...params,
                pagination: { ...params.pagination, total: total }
            });
        } catch (error) { throw new Error(error); }
        finally { tableBase.loaded(); }
    }, [tableBase.tableParams])

    const getTableProps = () => tableBase.getTableProps(items, handleTableChange, columns);

    const getItemSelected = () => items.find(it => it.id === editID);

    const newItem = () => { setEditID(0); modalBase.open(); }

    const editItem = (item) => { setEditID(item.id); modalBase.open(); }

    const saveItem = async (item) => {
        let res = (!item.id) ? await ApiConnector.post(`${url_endpoint}`, item, ) :
            await ApiConnector.put(`${url_endpoint}/${item.id}`, item);
        await fillItems();
        notification.success({
            description: "Item guardado correctamente."
        });

        if(res.status === 200) { setEditID(res.data.id); return res.data.id; }
    }

    const deleteItem = (id) => {
        modal.confirm({
            title: "Confirmación",
            content: "¿Eliminar item?",
            onOk: async () => {
                await ApiConnector.delete(`${url_endpoint}/${id}`);
                fillItems();
            }
        })
    }

    return {
        updateToken,
        getTableProps,
        FormBase,
        fillItems,
        getItemSelected,
        newItem,
        saveItem,
        editID,
        modalBase
    };
}
